export default {
  desktop: {
    ThemeImporter: () => import(/* webpackChunkName: "stanleybet-themeWrap" */'./ThemeImporter'),
  },
  mobile: {
    ThemeImporter: () => import(/* webpackChunkName: "stanleybet-themeWrap" */'./ThemeImporter'),
  },
};
